import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';
import V2Title from '@/common/components/Feedback/V2Title';
import { Col, Row } from 'antd';
import { FC, forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { capitalize, isArray, isNotEmptyAny } from '@lhb/func';
import { editFieldDefaultConfig, imagePropertyNames } from '../../shopEdit/ts-config';
import { useMethods } from '@lhb/hook';
import DetailRecord from './DetailRecord/index';
import { globalExpansionTaskAlias } from '@/common/utils/ways';
import UserInfoContext from '@/layout/context';
import FranchiseeDetailDrawer from '@/common/components/business/ExpandStore/FranchiseeDetailDrawer';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import { ShopStatus } from '../../shop/ts-config';
// import { ShopDetailAdditionalItems } from '../ts-config';
// import AreaDetailDrawer from '@/common/components/business/YouthMap/AreaDetailDrawer';
import AreaDetailDrawer from 'src/common/components/business/AreaDetailDrawer/index';
import PointDetailDrawer from 'src/views/youth/pages/map/components/LeftContent/DistrictDimension/RightCon/PointDetailDrawer/index';
import SpotevaluationAreaDetailDrawer from 'src/views/spotevaluation/pages/index/components/AreaDetailDrawer/index';
import MXBCModule from './MXBCModule';
import { kaXTC } from '@/ka/xtc/config';
import {
  getMatchModelClusterScore,
  getShopEditApprovalField,
  getShopEditApprovalFieldAssets,
  getShopEditApprovalFieldRawValue,
  getShopEditApprovalFieldStyle,
  getShopEditApprovalFieldValue,
  ShopEditApprovalFieldChange,
} from './shopEditApprovalSnapshot';

interface DetailMainProps {
  ref?: any;
  detail: any;
  isApproval?: boolean;
  style?: any;
  reload?: any
  isMXBC?: boolean;
  approvalFieldChanges?: ShopEditApprovalFieldChange[];
}

/**
 * 门店详情（调用场景：门店详情/合同签约审批详情）
 * @param param0
 * @returns
 */
const DetailMain: FC<DetailMainProps> = forwardRef(({ detail, isApproval = false, style, reload,
  isMXBC,
  approvalFieldChanges = [],
}, ref) => {

  useImperativeHandle(ref, () => ({
    reloadAll: methods.reload,
  }));

  const detailRecordRef: any = useRef();
  const [configs, setConfigs] = useState<any>([]);
  const RNET_MODE_NAME_BROKERRAGE = 2; // 租金模式-扣点
  const RNET_MODE_NAME_RARISE = 3; // 租金模式-取高
  const [detailData, setDetailData] = useState<any>({
    open: false,
  }); // 加盟商详情数据
  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息
  // const franchiseeAlias = globalFranchiseeAlias(globalAliasItemVOs);
  const expansionTaskAlias = globalExpansionTaskAlias(globalAliasItemVOs);
  const { tenantCheckInfo } = useTenantCheckInfo(); // 租户信息;
  const isXTC = kaXTC(tenantCheckInfo); // 使用kaXTC不需要传tenantCheckInfo的，这里是为了兼容历史逻辑

  // 商圈详情抽屉
  const [drawerData, setDrawerData] = useState<any>({
    open: false,
    modelClusterId: null, // 商圈id
    modelConfigId: null, // 商圈模型配置id
  });
  // 点位测评-商圈详情抽屉
  const [spotevaluationDrawerData, setSpotevaluationDrawerData] = useState<any>({
    open: false,
    cityId: '',
    cityName: '',
    lng: '',
    lat: '',
    poiName: '',
    modelClusterId: '', // 商圈id
    modelConfigId: '', // 商圈模型配置id
    type: '', // 评测类型
    poiSearchType: 1,
  });

  // 点位详情抽屉
  const [pointDrawerData, setPointDrawerData] = useState<any>({
    open: false,
    businessId: null,
    pointId: null
  });

  useEffect(() => {
    if (!detail?.configs && !isArray(detail?.configs)) return;
    /**
     * 过滤列表不显示的信息
     */
    // 当前页不展示「开发人员」字段（managerId）
    const result = detail?.configs?.filter(item => item.checked && item.code !== 'managerId')?.map(item => {
      item.config = editFieldDefaultConfig[item.field];
      return item;
    }) || [];

    // const allFields = [...result, ...ShopDetailAdditionalItems];

    methods.setHiddenField(result, detail.rentMode);
    setConfigs(result?.filter(item => !item.hidden));

  }, [detail?.configs]);

  const methods = useMethods({
    reload() {
      detailRecordRef.current?.init();
      reload?.();
    },
    /**
     * 设置隐藏字段
     * @param fields 显示fileds
     * @param currentValue 当前选中值，
     */
    setHiddenField(fields, currentValue = '') {
      if (!isNotEmptyAny(fields)) return;
      const fieldMap = (Array.isArray(fields) ? fields : []).reduce((result, item) => {
        result[item.field] = item;
        return result;
      }, {});
      const firstYearMonthRentField = fieldMap['firstYearMonthRent'];
      const secondYearMonthRentField = fieldMap['secondYearMonthRent'];
      const thirdYearMonthRentField = fieldMap['thirdYearMonthRent'];
      const brokerageField = fieldMap['brokerage'];

      // 已闭店显示时间和原因
      if (detail?.status !== ShopStatus.CLOSED) {
        fieldMap['closeDate'] && (fieldMap['closeDate'].hidden = true);
        fieldMap['closeReason'] && (fieldMap['closeReason'].hidden = true);
      }

      if (+currentValue === RNET_MODE_NAME_BROKERRAGE) { // 扣点模式
        firstYearMonthRentField && (firstYearMonthRentField.hidden = true);
        secondYearMonthRentField && (secondYearMonthRentField.hidden = true);
        thirdYearMonthRentField && (thirdYearMonthRentField.hidden = true);
        brokerageField && (brokerageField.hidden = false);
      } else if (+currentValue === RNET_MODE_NAME_RARISE) { // 租金模式-取高模式
        firstYearMonthRentField && (firstYearMonthRentField.hidden = false);
        secondYearMonthRentField && (secondYearMonthRentField.hidden = false);
        thirdYearMonthRentField && (thirdYearMonthRentField.hidden = false);
        brokerageField && (brokerageField.hidden = false);
      } else if (!currentValue) { // 如果没有设置值
        firstYearMonthRentField && (firstYearMonthRentField.hidden = true);
        secondYearMonthRentField && (secondYearMonthRentField.hidden = true);
        thirdYearMonthRentField && (thirdYearMonthRentField.hidden = true);
        brokerageField && (brokerageField.hidden = true);
      } else { // 其他模式
        firstYearMonthRentField && (firstYearMonthRentField.hidden = false);
        secondYearMonthRentField && (secondYearMonthRentField.hidden = false);
        thirdYearMonthRentField && (thirdYearMonthRentField.hidden = false);
        brokerageField && (brokerageField.hidden = true);
      }


      setConfigs(fields);
    },

    /**
     * 获取筛选项的值
     * @param val
     * @returns
     */
    getDetailItemValue(val: any) {
      return getShopEditApprovalFieldValue(approvalFieldChanges, val, detail);
    },
    getDetailItemAssets(val: any) {
      return getShopEditApprovalFieldAssets(approvalFieldChanges, val, detail);
    },
    getItemsType(item) {
      if (!item) {
        return 'text';
      }

      if (['text', 'textarea', 'link', 'files', 'images', 'domExpand'].includes(item.controlType)) {
        return item.controlType;
      } else {
        const codeTypeMap = {
          'franchiseeName': 'link',
          'matchModelClusterScore': 'link',
        };
        return codeTypeMap[item.code] || 'text';
      }
    },
    isApprovalFieldChanged(item: any) {
      return getShopEditApprovalField(approvalFieldChanges, item).changed;
    },
    /**
   * @description 点击名称查看拓店任务详情
   */
    handleFranchiseeName() {
      detail?.franchiseeId && setDetailData({
        open: true,
        id: detail.franchiseeId,
      });
    },

    /** 点击商圈评分跳转商圈详情 */
    handleMatchModelClusterScore() {
      const matchModelClusterScore = getMatchModelClusterScore(getShopEditApprovalFieldRawValue(
        approvalFieldChanges,
        {
          field: 'matchModelClusterScore',
          code: 'matchModelClusterScore',
        },
        detail,
      ));
      const { isInCluster, modelClusterId, modelConfigId } = matchModelClusterScore || {};
      if (isInCluster && modelClusterId) {
        setDrawerData({
          open: true,
          modelConfigId,
          id: modelClusterId,
        });
      } else {
        setSpotevaluationDrawerData({
          open: true,
          modelConfigId,
          isInCluster,
          modelClusterId,
          cityId: detail?.cityId,
          cityName: detail?.cityName,
          lng: detail?.lng,
          lat: detail?.lat,
          type: 1, // 点位测评类型 默认1 街边店
          radius: detail?.radius || 500, // 默认500m
          poiSearchType: 1,
        });
      }
    },

  });

  return (
    <div style={{ ...style }}>
      <V2Title type='H2' text='基本信息' divider/>
      <V2DetailGroup block={!isApproval}>
        <Row gutter={16}>
          {configs?.map(item => {
            const isApprovalFieldChanged = methods.isApprovalFieldChanged(item);
            const approvalFieldStyle = getShopEditApprovalFieldStyle(isApprovalFieldChanged);
            return (<Col span={8} key={item.code}>
              {item.controlType === 'fileUpload'
                ? <V2DetailItem
                  label={item.name}
                  type={imagePropertyNames.includes(item.code) ? 'images' : 'files'}
                  assets={methods.getDetailItemAssets(item)}
                  labelStyle={approvalFieldStyle.labelStyle}
                />
                : <V2DetailItem
                  label={item.name}
                  type={methods.getItemsType(item)}
                  onClick={methods.getItemsType(item) === 'link' && methods[`handle${capitalize(item.code)}`]}
                  labelStyle={approvalFieldStyle.labelStyle}
                  valueStyle={approvalFieldStyle.valueStyle}
                  value={methods.getDetailItemValue(item)} />
              }
            </Col>);
          })}
        </Row>
      </V2DetailGroup>
      {
        isMXBC && <MXBCModule detail={detail}/>
      }
      {/* 拓店日志（小天才暂时不显示） */}
      {(isNotEmptyAny(detail) && !isApproval && !isXTC) && <DetailRecord detail={detail} reload={reload} ref={detailRecordRef} expansionTaskAlias={expansionTaskAlias} />}
      {/* 加盟商详情 */}
      <FranchiseeDetailDrawer
        detailData={detailData}
        setDetailData={setDetailData}
        onSearch={reload}
        // franchiseeAlias={franchiseeAlias}
      />

      {/* 商圈详情抽屉（旧版第三代） */}
      <AreaDetailDrawer
        modelId={drawerData.modelConfigId}
        drawerData={drawerData}
        setDrawerData={setDrawerData}
        viewChanceDetail={false}
        showCollect={false}
      />
      {/* 商圈详情抽屉 */}
      {/* <AreaDetailDrawer
        modelConfigId={drawerData.modelConfigId}
        setDrawerData={setDrawerData}
        drawerData={drawerData}
        pointDrawerData={pointDrawerData}
        setPointDrawerData={setPointDrawerData}
      /> */}
      {/* 点位详情抽屉 */}
      <PointDetailDrawer
        modelConfigId={drawerData.modelConfigId}
        pointDrawerData={pointDrawerData}
        setPointDrawerData={setPointDrawerData}
        setDrawerData={setDrawerData}
        drawerData={drawerData}
      />
      {/* 点位测评-商圈详情抽屉 */}
      <SpotevaluationAreaDetailDrawer
        drawerData={spotevaluationDrawerData}
        setDrawerData={setSpotevaluationDrawerData}
      />
    </div>
  );
});

export default DetailMain;
